import {
    AfterContentInit, AfterViewInit, Component, ElementRef, HostBinding, HostListener, Input, OnInit, ViewChild
} from '@angular/core';
import {NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {GetValueAccessorProvider, ValueAccessorBase} from '../common/value-accessor-base';

@Component({
    selector: 'ui-check-box',
    templateUrl: './check-box.html',
    styleUrls: ['./check-box.scss'],
    providers: [GetValueAccessorProvider(CheckBoxComponent)],
    imports: [NgIf, FormsModule]
})
export class CheckBoxComponent
    extends ValueAccessorBase<boolean> implements OnInit, AfterContentInit, AfterViewInit {
    showLabel = false;
    @Input() id?: string;
    @Input() name = '';
    @Input() tabindex = 0;
    @ViewChild('label') label: ElementRef;
    @Input() switcher;
    @HostBinding('class.disabled') @Input() disabled = false;
    @HostBinding('class.invalid') @Input() invalid = false;

    constructor() {
        super();
    }

    ngOnInit() {
    }

    @HostListener('click')
    onClick() {
        this.value = !this.value;
    }

    @HostListener('keydown.space')
    onKeySpace() {
        this.value = !this.value;
    }

    ngAfterViewInit() {
    }

    ngAfterContentInit() {
        setTimeout(() => {
            this.showLabel =
                this.label.nativeElement.innerHTML.trim().length > 0;
        });
    }

    modeToggleSwitch() {
        if (!this.disabled) {
            this.value = !this.value;
        }
    }
}
